/* eslint-disable no-param-reassign */
import uuid from '@utils/uuid';
import Cookies from './cookies';

const sendUa = (eventName, eventData, extraData = {}) => {
  if (!(typeof window.ua === 'undefined')) {
    window.ua('send', eventName, eventData, extraData);
  }
};

const sendEventUa = (eventName, event, options = { force: true }) => {
  sendUa(eventName, event, options);
};

const sendLessonSecondWatchArray = (watchEvent) => {
  sendEventUa('lesson_watch_status', watchEvent, { force: true });
};

const videoPlayerWatchEnd = (event, options = { force: true }) => {
  sendEventUa('player_watch_end', event, options);
};

const videoPlayerWatched = (event, options = { force: true }) => {
  sendEventUa('player_video_watch', event, options);
};

const videoPlayerView = (event, options = { force: true }) => {
  sendEventUa('video_view', event, options);
};

const videoPlayerWatchStart = (event, options = { force: true }) => {
  sendEventUa('player_watch_start', event, options);
};

const sendWatchEvent = (event) => {
  videoPlayerWatchEnd(event, {
    force: false
  });
  videoPlayerWatched(event);
};

const s4 = () => {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
};

const guid = () => {
  return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

const oneSecWatched = (watchEvent) => {
  videoPlayerView(watchEvent);
  videoPlayerWatchStart(watchEvent, {
    force: true
  });
};

const watchEventCallback = (
  secondsWatched,
  watchEvent,
  prevUACallTime,
  force = false
) => {
  if (force || (secondsWatched >= 10 && secondsWatched > prevUACallTime + 10)) {
    watchEvent.TOTAL_WATCH_TIME_END = secondsWatched - prevUACallTime;
    sendWatchEvent(watchEvent);
    sendLessonSecondWatchArray(watchEvent);
    return secondsWatched;
  }
  return prevUACallTime;
};

const unmountChanges = (watchEvent) => {
  watchEventCallback(watchEvent.TOTAL_RUN_TIME, watchEvent);
  sendLessonSecondWatchArray(watchEvent);
};

const setBrowserId = () => {
  const id = guid();
  Cookies.setCookie('BROWSER_ID', id, 3024000);
  return id;
};

const setPlayerId = () => {
  const id = uuid();
  return id;
};

export default {
  setPlayerId,
  setBrowserId,
  unmountChanges,
  watchEventCallback,
  oneSecWatched,
  sendUa
};
